import { connect } from 'react-redux';

import Input from './Input';

const mapStateToProps = ({ user: { user } }) => ({ user });

export default connect(mapStateToProps)(Input);
